import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    dropzoneParagraph: {
        padding: theme.spacing(3),
        fontSize: '14px',
        textAlign: 'center',
        color: theme.palette.primary.dark,
        '&:hover': {
            cursor: 'pointer',
        },
    },
    dropzone: {
        border: '2px dashed #dfe3e8',
        borderRadius: '3px',
        backgroundColor: '#FFF',
        minHeight: '100px',
        margin: 0,
        marginTop: theme.spacing(2),
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        overflow: 'auto',
        boxSizing: 'border-box',
    },
    imgDeleteButton: {
        marginLeft: 'auto',
    },
}));
